import axios from '@/api/axios.config'
import type {
  EditorCharacterStylingInput,
  EditorThemeRoleDecorationWriteResult,
} from '@messenger/lotus/row-store'

export const setEditorThemeRoleDecoration = async (
  themeId: string,
  role: string,
  characterStyling: EditorCharacterStylingInput,
) =>
  await axios.put<EditorThemeRoleDecorationWriteResult>(
    `editor/themes/${themeId}/decorations/${role}`,
    { characterStyling },
  )
